export default "__VITE_PUBLIC_ASSET__ff5adc77__"